import PromotionsContainer from './promotions-container'

export default PromotionsContainer
